/*
 * Jira Ticket:
 * Created Date: Thu, 23rd Apr 2020, 13:13:48 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneEmploymentQuery = gql`
  query Employment($id: ID!) {
    data: Employment(id: $id) {
      id
      organisation {
        id
        name
      }
      type
      role
      projects {
        id
        name
      }
      user {
        id
        email
      }
      status
    }
  }
`;
